import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExampleComponent } from './components/example/example.component';
import { RouterModule } from '@angular/router';


@NgModule({
    declarations: [
        ExampleComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([{
            path: 'redux-demo',
            component: ExampleComponent,
            data: { state: 'redux-demo' },
            // canActivate: [AuthorizationGuard],
            // canLoad: [AuthorizationCanGuard]
        },])

    ],

})
export class ReduxDemoModule {
    constructor() {
        //  we pass in the interface of store we created for demo purpose here
        //  <> this is for generic parameter

        // in the above statement we are initialising out store,first argument is our reducer,
        // the second argument is our initial store
    }

}
